import type { ApInvoiceListReturnContext } from "@/accounts-payable/types";
import { apListPath } from "@/accounts-payable/utils";

const AP_LIST_PATH = apListPath();

export const isInvoiceListReturnContext = (
  value: unknown,
): value is ApInvoiceListReturnContext => {
  if (!value || typeof value !== "object") return false;
  if (
    !("businessId" in value) ||
    typeof value.businessId !== "string" ||
    !("listPath" in value) ||
    typeof value.listPath !== "string"
  )
    return false;
  const path = value.listPath;
  return (
    path === AP_LIST_PATH ||
    path.startsWith(`${AP_LIST_PATH}?`) ||
    path.startsWith(`${AP_LIST_PATH}#`)
  );
};

/** Only return to a local AP list from the same business. */
export const readInvoiceListReturnPath = (
  state: unknown,
  businessId: string | null,
): string | null => {
  if (
    !businessId ||
    !state ||
    typeof state !== "object" ||
    !("invoiceListReturnContext" in state)
  )
    return null;
  const context = state.invoiceListReturnContext;
  return isInvoiceListReturnContext(context) &&
    context.businessId === businessId
    ? context.listPath
    : null;
};
